import {Component} from "@angular/core";
import {ArianeElement, ArianeStore, CssInjectorService, UserStore, CorrespondantStore} from "@digicerba/common";

@Component({
  selector: 'accueil-component',
  templateUrl: './accueil.component.html',
  host: { 'class': 'page' }
})
export class AccueilPageComponent {

  constructor(arianeStore: ArianeStore, private cssInjector: CssInjectorService,
              private userStore: UserStore,
              private correspondantStore: CorrespondantStore) {

    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.HOME",
        route: "/accueil"
      }
    ];
    arianeStore.updateElements(arianeElements);
  }

  ngAfterViewInit() {
    this.cssInjector.injectCss("catalogue-examens/catalogue-examens.css");
  }

  isGuest(): boolean {
    let role = this.userStore.getUser().role;
    return role == "INVITE";
  }

  isFr(): boolean {
    return this.correspondantStore.hasTag("fr") && !this.correspondantStore.hasTag("en") && !this.correspondantStore.hasTag("fra");
  }

  /**
   * Check les tags du correspondant en cours pour savoir si on a
   * accès à la partie modification du catalgue examen
   *
   * @returns {boolean} true si le tag pour avoir accès est présent
   * ============================================================== */
  isAuthToCatalogUpdate(): boolean {
    return this.correspondantStore.hasTag("majcatalogue");
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/accueil/accueil.component.ts